import { render } from "./MovementInstructionLotDocuments.vue?vue&type=template&id=3f7b9ff0&scoped=true"
import script from "./MovementInstructionLotDocuments.vue?vue&type=script&lang=js"
export * from "./MovementInstructionLotDocuments.vue?vue&type=script&lang=js"

import "./MovementInstructionLotDocuments.vue?vue&type=style&index=0&id=3f7b9ff0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7b9ff0"]])

export default __exports__